
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M0 7.163v-.268C0 3.639 2.627 1 5.867 1h4.266C13.373 1 16 3.64 16 6.895c0 3.24-2.602 5.87-5.82 5.894l-2.652 2.22c-1.083.908-2.728.133-2.728-1.283v-.993A5.62 5.62 0 010 7.163zm6.504 6.611L9.35 11.39a.893.893 0 01.573-.208h.21c2.356 0 4.266-1.92 4.266-4.287 0-2.368-1.91-4.287-4.267-4.287H5.867C3.51 2.608 1.6 4.528 1.6 6.895v.268c0 2.22 1.79 4.019 4 4.019a.801.801 0 01.8.804v1.74c0 .054.063.083.104.048zM4 5.8a.8.8 0 01.8-.8h6.4a.8.8 0 110 1.6H4.8a.8.8 0 01-.8-.8zm.8 1.6a.8.8 0 000 1.6h4a.8.8 0 000-1.6h-4z"}})])
          )
        }
      }
    